import { render, staticRenderFns } from "./baseview.vue?vue&type=template&id=2cc16d3c&scoped=true"
import script from "./baseview.vue?vue&type=script&lang=js"
export * from "./baseview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc16d3c",
  null
  
)

export default component.exports